<div>
  <table class="custom-table-list" aria-label="cred_table">
    <thead>
      <tr class="custom-table-list-headings">
        <th class="custom-col-width-30">Department Name</th>
        <th class="custom-col-width-30">User Count</th>
        <th class="custom-col-width-20 th-last">Action</th>
      </tr>
    </thead>
    <tbody>
      @for (department of departments; track department) {
        <tr class="custom-table-list-row-main">
          <td class="custom-col-width-30">{{ department.name }}</td>
          <td class="custom-col-width-30">{{ department.userCount || "-" }}</td>
          <td class="custom-col-width-20 td-last">
            @if (hasEditAccess(department)) {
              <span class="d-flex justify-content-start">
                <span data-bs-toggle="tooltip" ngbTooltip="Edit" [placement]="'left'"
                  (click)="isEditDepartment(department)">
                  <div tooltipClass="custom-tooltip" class="btn btn-primary btn-sm me-2 custom-button">
                    <fa-icon [icon]="faEdit"></fa-icon>
                  </div>
                </span>
                <span data-bs-toggle="tooltip" ngbTooltip="DELETE" [placement]="'left'"
                  (click)="deleteDepartment(department)">
                  <div class="btn btn-primary btn-sm me-2 fa-icon-class custom-button">
                    <fa-icon [icon]="faTrash"></fa-icon>
                  </div>
                </span>
              </span>
            }
          </td>
        </tr>
      }
      @if (loadRecords) {
        <tr class="custom-table-list-row-main">
          <td class="custom-col-width-100 text-danger d-flex justify-content-center">
            <app-common-icon [loadingIcon]="loadRecords"></app-common-icon>
          </td>
        </tr>
      }
      @if (departments?.length === 0) {
        <tr>
          <td class="custom-col-width-100 text-danger d-flex justify-content-center">
            No Data Found
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
<div class="overlay" [class.show]="openDepartmentPanel"></div>
@if (openDepartmentPanel) {
  <div class="off-canvas width-450" [class.show]="openDepartmentPanel">
    <div class="off-canvas-content">
      <app-add-department [isEdit]="isEdit" [selectedDepartment]="selectedDepartment"
        (successToster)="successTosterFromAddDepartmentComponent($event)"
      (closePanel)="closeDepartmentPanel()"></app-add-department>
    </div>
  </div>
}

@if (isErrorToster) {
  <div class="toaster_message">
    <app-error-toaster [title]="tosterMessage" (closeToaster)="closingToster($event)"></app-error-toaster>
  </div>
}

@if (isSuccessToster) {
  <div class="toaster_message">
    <app-toast [title]="tosterMessage" (closeToaster)="closingToster($event)"></app-toast>
  </div>
}

<div class="footer-page-ination">
  <app-paginator [totalCount]="totalRecords" [showFirstLastIcon]="true" (selectedPage)="onPageChange($event)">
  </app-paginator>
</div>